export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const NODE_ENV = process.env.REACT_APP_NODE_ENV;
export const PIXEL_ID = process.env.REACT_APP_PIXEL_ID;
export const REFRESH_KEY = 'MurabahaRefreshToken';
export const ACCESS_KEY = 'MurabahaAccessToken';
export const DEFAULT_ERROR_MESSAGE = 'An error occurred when submitting your request. Please try again soon.';

export const IS_DEVELOPMENT = NODE_ENV === 'development';

/* eslint-disable */
export const noop = () => { };